'use client';

import dynamic from 'next/dynamic';

const TmaApp = dynamic(() => import('./TmaApp'), { ssr: false });

export default function TmaAppMount() {
  return <TmaApp />;
}
